import {JetView} from "webix-jet"; // Importing JetView class from webix-jet for creating views
import {getCities} from "models/cities"; // Importing getCities function from cities model
import {getTags} from "models/tags"; // Importing getTags function from tags model
import {getPositions} from "models/positions"; // Importing getPositions function from positions model
import "webix/photo"; // Importing photo module from webix for image handling
import "webix/tinymce/tinymce"; // Importing TinyMCE editor from webix for rich text editing
import {profile, devConfig, countries, paymentSystem, cashDesks, agentList} from "config/config"; // Importing various configuration constants

/**
 * Class representing the FilterWithdrawalRequestView.
 * @extends JetView
 */
export default class FilterWithdrawalRequestView extends JetView {
    /**
     * Configures the UI components and data fetching for the application.
     */
    config() {
        const _ = this.app.getService("locale")._; // Localization function
        const lang = this.app.getService("locale").getLang(); // Current language
        let country = ""; // Variable to hold the selected country

        // Check if country report is enabled in the configuration
        if (devConfig.getCountryReport()) {
            country = profile.Settings.ReportCountry; // Get the report country from profile settings
            webix.ajax().headers({
                "Content-type": "application/json" // Set content type for the AJAX request
            }).post(devConfig.geturlApi() + "es/Select/ProviderCashOutSelect", {Country: country}, {
                error: function (text, data, XmlHttpRequest) {
                    webix.message("Error! "); // Display error message on failure
                },
                success: function (text, data, XmlHttpRequest) {
                    var resp = JSON.parse(text); // Parse the response text
                    $$("SubproviderId").define("options", resp.data); // Define options for SubproviderId
                }
            });
        }

        // Define the layout for the left section of the UI
        const left = {
            margin: 5,
            id: "a1",
            rows: [
                {
                    margin: 15,
                    css: "on-row",
                    responsive: "a1",
                    cols: [
                        {
                            view: "text", name: "Datepicker", id: 'Datepicker', css: "reportrange", minWidth: 200,
                            label: "<span class='webix_icon icon-calendar'></span>" + _("Fecha"), labelPosition: "top",
                            placeholder: _("Click para seleccionar "), // Placeholder text for date picker
                        },
                        {
                            view: "datepicker", name: "Date", id: "Date", stringResult: true, minWidth: 200,
                            label: "<span class='webix_icon icon-calendar'></span>" + _("Fecha"), labelPosition: "top",
                            placeholder: _("Click para seleccionar "), value: moment().format('YYYY-MM-DD'), // Default value set to today's date
                            format: "%d %M %Y",
                            suggest: {
                                type: "calendar",
                                body: {
                                    maxDate: new Date() // Limit the date picker to not allow future dates
                                }
                            }
                        },
                        {
                            view: "text",
                            name: "PlayerId",
                            minWidth: 200,
                            label: "<span class='icon-drivers-license-o'></span>" + _("ID Cliente"),
                            labelPosition: "top",
                            placeholder: _("ID Cliente"),
                            invalidMessage: _("Client ID is required") // Validation message for PlayerId
                        },
                        {
                            view: "text",
                            name: "WithdrawId",
                            type: "number",
                            minWidth: 200,
                            label: "<span class='icon-drivers-license-o'></span>" + _("ID Retiro"),
                            labelPosition: "top",
                            placeholder: _("ID Retiro"),
                            invalidMessage: _("Withdraw ID is required") // Validation message for WithdrawId
                        },
                        {
                            view: "richselect", name: "State", minWidth: 200,
                            label: "<span class='icon-state'></span>" + _("Estado"), labelPosition: "top",
                            placeholder: _("Click para seleccionar "), // Placeholder for state selection
                            options: [
                                { id: '', value: _("Todos") },
                                { id: 'A', value: _("Activo") },
                                { id: 'I', value: _("Inactivo") },
                                { id: 'R', value: _("Rechazado") },
                                { id: 'P', value: _("Pendiente") },
                                { id: 'E', value: _("Eliminado") },
                                { id: 'D', value: _("Devueltas") },
                                { id: 'PS', value: _("Pendiente por Sistema") },
                                { id: 'AS', value: _("Aprobado por Sistema") },
                                { id: 'RS', value: _("Rechazado por Sistema") },
                                { id: 'M', value: _("Pendiente por aprobación") },
                                { id: 'X', value: _("Procesando") },
                                { id: 'W', value: _("Expirado por tiempo") },
                                { id: 'Z', value: _("Expirado por OTP") },
                                { id: 'O', value: _("Pendiente por OTP") }
                            ]
                        }
                    ]
                },
                {
                    margin: 15,
                    css: "on-row",
                    responsive: "a1",
                    cols: [
                        {
                            view: "text", name: "Ip", minWidth: 200,
                            label: "<span class='icon-ip'></span>" + _("Dirección IP"), labelPosition: "top",
                            placeholder: _("Dirección IP") // Placeholder for IP address input
                        },
                        {
                            view: "checkbox",
                            label: _("Por fecha de retiro pagado"), // Checkbox label
                            labelPosition: "top",
                            name: "ByAllowDate",
                            value: 0,
                            minWidth: 200,
                        },
                        {
                            view: "richselect", name: "PaymentMethods", minWidth: 200,
                            label: "<span class='icon-credit-card'></span>" + _("Formas de Pago"), labelPosition: "top",
                            placeholder: _("Click para seleccionar "), // Placeholder for payment methods selection
                            options: [
                                { id: '0', value: _("Todos") },
                                { id: '1', value: _("Efectivo") },
                                { id: '2', value: _("Cuenta Bancaria") },
                                { id: '3', value: _("Giro Bancario") },
                                { id: '4', value: _("Criptomoneda") }
                            ]
                        },
                        {
                            hidden: devConfig.getPermAction("filterByBetShop", "Add"), // Conditional visibility based on permissions
                            css: "prm-filterByBetShop",
                            height: 1
                        },
                        {
                            view: "combo",
                            name: "BetShopId",
                            minWidth: 200,
                            label: "<span class='icon-shop'></span>" + _("Punto de Venta"),
                            hidden: !devConfig.getPermAction("filterByBetShop", "Add"), // Conditional visibility based on permissions
                            css: "prm-filterByBetShop",
                            labelPosition: "top",
                            placeholder: _("Click para seleccionar "), // Placeholder for BetShop selection
                            id: "BetShopId",
                            options: {
                                body: {
                                    dataFeed: function (text) {
                                        var vthis = this;
                                        if (text.length > 2) { // Trigger data fetch if input length exceeds 2
                                            webix.ajax().headers({
                                                "Content-type": "application/json"
                                            }).post(devConfig.geturlApi() + "es/Select/BetShopsSelect", '{"Filter":"' + text + '"}', {
                                                error: function (text, data, XmlHttpRequest) {
                                                    webix.message("Error! "); // Display error message on failure
                                                },
                                                success: function (text, data, XmlHttpRequest) {
                                                    var resp = JSON.parse(text); // Parse the response text
                                                    if (!resp.HasError) {
                                                        vthis.parse(resp.Data); // Populate the combo with fetched data
                                                    }
                                                }
                                            });
                                        }
                                    }
                                }
                            }
                        }
                    ]
                },
                {
                    margin: 15,
                    css: "on-row",
                    responsive: "a1",
                    cols: [
                        {
                            view: "richselect",
                            name: "PaymentMethodBankAccounts",
                            minWidth: 200,
                            label: "<span class='icon-credit-card'></span>" + _("Método de pago"),
                            labelPosition: "top",
                            placeholder: _("Click para seleccionar "), // Placeholder for bank account payment method selection
                            options: [
                                { id: '0', value: _("Todos") },
                                { id: '1', value: _("Pagado físicamente") },
                                { id: '2', value: _("Pagado por sistema") }
                            ]
                        },
                        {
                            view: "text", name: "ValueMinimum", type: "number", minWidth: 200,
                            label: "<span class='icon-cash'></span>" + _("Valor Mínimo"), labelPosition: "top",
                            placeholder: _("Valor Mínimo") // Placeholder for minimum value input
                        },
                        {
                            view: "text", name: "ValueMaximum", type: "number", minWidth: 200,
                            label: "<span class='icon-cash'></span>" + _("Valor Máximo"), labelPosition: "top",
                            placeholder: _("Valor Máximo") // Placeholder for maximum value input
                        },
                        {
                            hidden: devConfig.getPermAction("filterByCountry", "Add"), // Conditional visibility based on permissions
                            css: "prm-filterByCountry",
                            height: 1
                        },
                        {
                            view: "richselect", name: "Categorization",
                            label: _("Categorización"), labelPosition: "top",
                            placeholder: _("Click para seleccionar "), // Placeholder for categorization selection
                            options: [ "1", "2", "3", "4", "5"],
                        },
                    ]
                },
                {
                    margin: 15,
                    css: "on-row",
                    responsive: "a1",
                    cols: [
                        {
                            view: "richselect",
                            name: "CountrySelect",
                            id: "CountrySelect",
                            minWidth: 200,
                            label: "<span class='icon-language'></span>" + _("País"),
                            labelPosition: "top",
                            placeholder: _("Click para seleccionar "), // Placeholder for country selection
                            options: {
                                body: {
                                    template: function (obj) {
                                        return "<i class='flags " + obj.icon + "'></i>" + obj.value; // Custom template for country options
                                    },
                                    data: countries // Data source for country options
                                }
                            },
                            hidden: devConfig.getCountryReport() || !devConfig.getPermAction("filterByCountry", "Add"), // Conditional visibility based on permissions
                            css: "prm-filterByCountry",
                            on: {
                                onChange: function (data, obj) {
                                    var currentValue = this.getValue(); // Get the selected value
                                    if (currentValue.length > 0) {
                                        country = currentValue; // Update the country variable
                                        webix.ajax().headers({
                                            "Content-type": "application/json"
                                        }).post(devConfig.geturlApi() + "es/Select/ProviderCashOutSelect", {Country: country}, {
                                            error: function (text, data, XmlHttpRequest) {
                                                webix.message("Error! "); // Display error message on failure
                                            },
                                            success: function (text, data, XmlHttpRequest) {
                                                var resp = JSON.parse(text); // Parse the response text
                                                $$("SubproviderId").define("options", resp.data); // Define options for SubproviderId
                                            }
                                        });
                                    }
                                }
                            }
                        },
                        {
                            view: "richselect",
                            name: "CountrySelect2",
                            minWidth: 200,
                            label: "<span class='icon-language'></span>" + _("País"),
                            labelPosition: "top",
                            placeholder: _("Click para seleccionar "), // Placeholder for country selection
                            value: profile.Settings.ReportCountry, // Default value from profile settings
                            readonly: true, // Make this field read-only
                            options: {
                                body: {
                                    template: function (obj) {
                                        return "<i class='flags " + obj.icon + "'></i>" + obj.value; // Custom template for country options
                                    },
                                    data: countries // Data source for country options
                                }
                            },
                            hidden: !devConfig.getCountryReport() || !devConfig.getPermAction("filterByCountry", "Add"), // Conditional visibility based on permissions
                            css: "prm-filterByCountry"
                        },
                        {
                            view: "radio",
                            name: "Type",
                            id: "Type",
                            label: _("Tipo"),
                            labelPosition: "top",
                            height: (screen.width < 500) ? 100 : 0, // Adjust height based on screen width
                            value: 0,
                            minWidth: 200,
                            options: [
                                {"id": 0, value: _("Detallado")}, // Detailed option
                                {"id": 1, value: _("Totales")} // Total option
                            ]
                        },
                        {
                            view: "text", name: "SystemId", minWidth: 200,
                            label: "<span class='icon-id'></span>" + _("Id Sistema"), labelPosition: "top",
                            placeholder: _("Id Sistema") // Placeholder for system ID input
                        },
                        {
                            view: "combo", name: "BankId", id: "BankId", minWidth: 200,
                            label: "<span class='icon-shop'></span>" + _("Banco"), labelPosition: "top",
                            placeholder: _("Click para seleccionar "), // Placeholder for bank selection
                            options: {
                                body: {
                                    dataFeed: function (text) {
                                        var vthis = this;
                                        if (text.length > 2) { // Trigger data fetch if input length exceeds 2
                                            webix.ajax().headers({
                                                "Content-type": "application/json"
                                            }).post(devConfig.geturlApi() + "es/Select/BanksSelect", '{"Filter":"' + text + '"}', {
                                                error: function (text, data, XmlHttpRequest) {
                                                    webix.message("Error! "); // Display error message on failure
                                                },
                                                success: function (text, data, XmlHttpRequest) {
                                                    var resp = JSON.parse(text); // Parse the response text
                                                    if (!resp.HasError) {
                                                        vthis.parse(resp.Data); // Populate the combo with fetched data
                                                    }
                                                }
                                            });
                                        }
                                    }
                                }
                            }
                        },
                    ]
                },
                {
                    margin: 15,
                    css: "on-row",
                    responsive: "a1",
                    cols: [
                        {
                            view: "combo", name: "SubproviderId", minWidth: 200, id: "SubproviderId",
                            label: "<span class='icon-shop'></span>" + _("Proveedor"), labelPosition: "top",
                            options: [], placeholder: _("Click para seleccionar ") // Placeholder for subprovider selection
                        },
                        {
                            view: "text", name: "PaymentChannel", minWidth: 200,
                            label: _("Canal de pago"), labelPosition: "top",
                            placeholder: _("Canal de pago") // Placeholder for payment channel input
                        },
                        {
                            view: "daterangepicker",
                            name: "ModifiedLocal",
                            id: "ModifiedLocal",
                            stringResult: true,
                            minWidth: 350,
                            timepicker: true,
                            label: "<span class='webix_icon icon-calendar'></span>" + _("Fecha Modificado"),
                            labelPosition: "top",
                            placeholder: _("Click para seleccionar "), // Placeholder for modified date range selection
                            format: "%Y-%m-%d %h:%i %a",
                        },
                        {
                            view: "text", name: "ManagerId", minWidth: 200,
                            label: _("ID Gestor"), labelPosition: "top",
                            placeholder: _("ID Gestor") // Placeholder for manager ID input
                        },
                        {gravity: 1, minWidth: 200} // Flexible space
                    ]
                },
                {
                    margin: 15,
                    css: "on-row",
                    responsive: "a1",
                    cols:[
                        {
                            hidden: !devConfig.getPermAction("filterByRiskStatus", "Add"), css:"prm-filterByRiskStatus RiskStatus-hide",
                            view: "multiselect", name: "RiskStatus", minWidth: 200,
                            label: "<span class='icon-state'></span>" + _("Filtrar por Nivel de Riesgo"), labelPosition: "top",
                            placeholder: _("Click para seleccionar "), // Placeholder for risk status selection
                            options: [
                                { id: 'A', value: _("Alto") }, // High risk option
                                { id: 'M', value: _("Medio") }, // Medium risk option
                                { id: 'B', value: _("Bajo") } // Low risk option
                            ]
                        },
                        {gravity: 1, minWidth: 200} // Flexible space
                    ]
                },
                {id: "grav2", cols: []} // Placeholder for additional content
            ]
        };

        // Define the layout for the second left section of the UI
        const left2 = {
            margin: 5,
            rows: [{
                margin: 15,
                css: "on-row",
                responsive: "a1",
                cols: [
                    {
                        view: "text",
                        name: "DateDelete",
                        id: 'DateDelete',
                        css: "reportrange2",
                        label: "<span class='webix_icon icon-calendar'></span>" + _("Fecha de Eliminación"),
                        labelPosition: "top",
                        placeholder: _("Click para seleccionar "), // Placeholder for deletion date selection
                        on: {
                            onFocus: function (o, e, v) {
                                devConfig.setDateModal(lang); // Set date modal based on language
                            }
                        }
                    },
                    {
                        view: "datepicker",
                        name: "DateDelete2",
                        id: "DateDelete2",
                        stringResult: true,
                        minWidth: 200,
                        label: "<span class='webix_icon icon-calendar'></span>" + _("Fecha de Eliminación"),
                        labelPosition: "top",
                        placeholder: _("Click para seleccionar "), // Placeholder for deletion date selection
                        value: moment().format('YYYY-MM-DD'), // Default value set to today's date
                        format: "%d %M %Y",
                        suggest: {
                            type: "calendar",
                            body: {
                                maxDate: new Date() // Limit the date picker to not allow future dates
                            }
                        }
                    },
                    {
                        view: "text",
                        name: "DatePay",
                        id: 'DatePay',
                        css: "reportrange3",
                        label: "<span class='webix_icon icon-calendar'></span>" + _("Fecha de pago"),
                        labelPosition: "top",
                        placeholder: _("Click para seleccionar "), // Placeholder for payment date selection
                        on: {
                            onFocus: function (o, e, v) {
                                devConfig.setDateModal(lang); // Set date modal based on language
                            }
                        }
                    },
                    {
                        view: "datepicker",
                        name: "DatePay2",
                        id: "DatePay2",
                        stringResult: true,
                        minWidth: 200,
                        label: "<span class='webix_icon icon-calendar'></span>" + _("Fecha de pago"),
                        labelPosition: "top",
                        placeholder: _("Click para seleccionar "), // Placeholder for payment date selection
                        value: moment().format('YYYY-MM-DD'), // Default value set to today's date
                        format: "%d %M %Y",
                        suggest: {
                            type: "calendar",
                            body: {
                                maxDate: new Date() // Limit the date picker to not allow future dates
                            }
                        }
                    }
                ]
            }]
        };

        // Define the upper section layout
        const upper_section = {
            css: "father-container",
            rows: [{
                margin: 10,
                cols: [
                    left // Include the left section
                ]
            }]
        };

        // Define the upper section 2 layout
        const upper_section2 = {
            css: "father-container",
            height: (screen.width < 500) ? 150 : 0, // Adjust height based on screen width
            rows: [{
                margin: 10,
                cols: [
                    left2 // Include the left2 section
                ]
            }]
        };

        /**
         * Converts a file to a Base64 string.
         * @param {File} file - The file to convert.
         * @returns {Promise<string>} - A promise that resolves with the Base64 string.
         */
        function getBase64(file) {
            return new Promise((resolve, reject) => {
                const reader = new FileReader(); // Create a FileReader instance
                reader.readAsDataURL(file); // Read the file as a data URL
                reader.onload = () => resolve(reader.result); // Resolve with the result on load
                reader.onerror = error => reject(error); // Reject on error
            });
        }

        var base64CSV = ""; // Variable to hold the Base64 encoded CSV data

        // Define the massive rejection window UI
        const massiveRejection = webix.ui({
            view: "window",
            id: "MassiveRejection",
            fullscreen: (screen.width < 500) ? true : false, // Fullscreen mode for small screens
            head: {
                view: "toolbar",
                cols: [
                    {view: "label", label: _("Rechazos masivo")}, // Title for the window
                    {
                        view: "icon", icon: "wxi-close", click: function () {
                            this.getTopParentView().hide(); // Close the window on icon click
                        }
                    }
                ]
            },
            position: "center",
            modal: true,
            body: {
                view: "form", id: "addMassiveRejectionForm",
                elements: [
                    {
                        margin: 10,
                        rows: [
                            {
                                view: "uploader", id: "uploader", value: _("Cargar archivo CSV"), // Uploader for CSV files
                                on: {
                                    onBeforeFileAdd: function (upload) {
                                        getBase64(upload.file).then(
                                            data => base64CSV = data // Convert file to Base64
                                        );
                                        $$("uploader").define("label", upload.name); // Update uploader label
                                        $$("uploader").refresh(); // Refresh uploader
                                    }
                                }
                            },
                            {
                                view: "textarea",
                                labelPosition: "top",
                                label: _("Descripción:"),
                                name: "Description",
                                labelWidth: 150,
                                required: true,
                                height: 150 // Textarea for description input
                            }
                        ]
                    },
                    {
                        cols: [
                            {
                                view: "button", value: _("Cancelar"), click: function () {
                                    this.getTopParentView().hide(); // Close the window on cancel
                                    $$('addMassiveRejectionForm').setValues($$('addMassiveRejectionForm').getCleanValues()); // Reset form values
                                    $$("uploader").define("label", _("Cargar archivo CSV")); // Reset uploader label
                                    $$("uploader").refresh(); // Refresh uploader
                                    base64CSV = ""; // Clear Base64 data
                                }
                            },
                            {
                                view: "button", type: "form", value: _("Guardar"), click: function ($e) {
                                    var values = $$("addMassiveRejectionForm").getValues(); // Get form values
                                    if ($$("addMassiveRejectionForm").validate() && base64CSV !== "") { // Validate form and check if CSV is uploaded
                                        webix.ajax().headers({
                                            "Content-type": "application/json"
                                        }).post(devConfig.geturlApi() + "Client/MassiveRejection", '{"CSV":"' + base64CSV + '","Type":"0' + '","Description":"' + values.Description + '"}', {
                                            error: function (text, data, XmlHttpRequest) {
                                                webix.message("Error! "); // Display error message on failure
                                            },
                                            success: function (text, data, XmlHttpRequest) {
                                                text = JSON.parse(text); // Parse the response text
                                                if (text.HasError) {
                                                    webix.message("Error: " + text.AlertMessage); // Display error message if there is an error
                                                } else {
                                                    webix.message("Rechazo masivo creado"); // Success message
                                                }
                                            }
                                        });
                                        this.getTopParentView().hide(); // Close the window after submission
                                    } else {
                                        webix.message({
                                            title: _("¡Mensaje!"),
                                            type: "alert-error",
                                            text: _("Completa los campos...") // Alert message for incomplete fields
                                        });
                                    }
                                }
                            }
                        ]
                    }
                ], elementsConfig: {
                    on: {
                        onChange: function () {
                            this.validate(); // Validate form on change
                        }
                    }
                }
            }
        });

        // Define the massive approval window UI
        const massiveApproval = webix.ui({
            view: "window",
            id: "MassiveApproval",
            fullscreen: (screen.width < 500) ? true : false, // Fullscreen mode for small screens
            head: {
                view: "toolbar",
                cols: [
                    {view: "label", label: _("Aprobaciones masivas")}, // Title for the window
                    {
                        view: "icon", icon: "wxi-close", click: function () {
                            this.getTopParentView().hide(); // Close the window on icon click
                        }
                    }
                ]
            },
            position: "center",
            modal: true,
            body: {
                view: "form", id: "addMassiveApprovalForm",
                elements: [
                    {
                        margin: 10,
                        rows: [
                            {
                                view: "uploader", id: "uploaderReject", value: _("Cargar archivo CSV"), // Uploader for CSV files
                                on: {
                                    onBeforeFileAdd: function (upload) {
                                        getBase64(upload.file).then(
                                            data => base64CSV = data // Convert file to Base64
                                        );
                                        $$("uploaderReject").define("label", upload.name); // Update uploader label
                                        $$("uploaderReject").refresh(); // Refresh uploader
                                    }
                                }
                            },
                            {
                                view: "textarea",
                                labelPosition: "top",
                                label: _("Descripción:"),
                                name: "Description",
                                labelWidth: 150,
                                required: true,
                                height: 150 // Textarea for description input
                            }
                        ]
                    },
                    {
                        cols: [
                            {
                                view: "button", value: _("Cancelar"), click: function () {
                                    this.getTopParentView().hide(); // Close the window on cancel
                                    $$('addMassiveApprovalForm').setValues($$('addMassiveApprovalForm').getCleanValues()); // Reset form values
                                    $$("uploader").define("label", _("Cargar archivo CSV")); // Reset uploader label
                                    $$("uploader").refresh(); // Refresh uploader
                                    base64CSV = ""; // Clear Base64 data
                                }
                            },
                            {
                                view: "button", type: "form", value: _("Guardar"), click: function ($e) {
                                    var values = $$("addMassiveApprovalForm").getValues(); // Get form values
                                    if ($$("addMassiveApprovalForm").validate() && base64CSV !== "") { // Validate form and check if CSV is uploaded
                                        webix.ajax().headers({
                                            "Content-type": "application/json"
                                        }).post(devConfig.geturlApi() + "Client/MassiveApproval", '{"CSV":"' + base64CSV + '","Type":"0' + '","Description":"' + values.Description + '"}', {
                                            error: function (text, data, XmlHttpRequest) {
                                                webix.message("Error! "); // Display error message on failure
                                            },
                                            success: function (text, data, XmlHttpRequest) {
                                                text = JSON.parse(text); // Parse the response text
                                                if (text.HasError) {
                                                    webix.message("Error: " + text.AlertMessage); // Display error message if there is an error
                                                } else {
                                                    webix.message("Aprobación masiva creada"); // Success message
                                                }
                                            }
                                        });
                                        this.getTopParentView().hide(); // Close the window after submission
                                    } else {
                                        webix.message({
                                            title: _("¡Mensaje!"),
                                            type: "alert-error",
                                            text: _("Completa los campos...") // Alert message for incomplete fields
                                        });
                                    }
                                }
                            }
                        ]
                    }
                ], elementsConfig: {
                    on: {
                        onChange: function () {
                            this.validate(); // Validate form on change
                        }
                    }
                }
            }
        });

        // Define the buttons layout
        const buttons = {
            margin: 10,
            cols: [
                {},
                {
                    view: "button", value: _("Pago masivo"),
                    autowidth: true,
                    hidden: !devConfig.getPermAction("massiveApprovalUserOnline", "Add"), // Conditional visibility based on permissions
                    click: () => {
                        massiveApproval.show(); // Show the massive approval window
                    }
                },
                {
                    view: "button", value: _("Rechazo masivo"),
                    autowidth: true,
                    hidden: !devConfig.getPermAction("massiveRejectionUserOnline", "Add"), // Conditional visibility based on permissions
                    click: () => {
                        massiveRejection.show(); // Show the massive rejection window
                    }
                },
                {
                    view: "button", value: _("Limpiar"), autowidth: true,
                    click: () => {
                        $$('myForm').setValues($$('myForm').getCleanValues()); // Reset form values
                    }
                },
                {
                    view: "button", value: _("Consultar"), hotkey: "enter", type: "form", autowidth: true,
                    click: () => {
                        const filterdata = this.getRoot().getValues(); // Get filter data from the form
                        if (devConfig.getCountryReport()) {
                            filterdata.CountrySelect = profile.Settings.ReportCountry; // Set country filter if enabled
                        }
                        delete filterdata['CountrySelect']; // Remove unnecessary fields
                        if (profile.typeDate !== 2) {
                            delete filterdata['Date'];
                            delete filterdata['DateDelete2'];
                            delete filterdata['DatePay2'];
                        } else {
                            if (true) {
                                delete filterdata['Datepicker'];
                                delete filterdata['DateDelete'];
                                delete filterdata['DatePay'];
                            }
                        }
                        this.app.callEvent("bonusReport:filter", [filterdata]); // Trigger filter event with the collected data
                        $$("b5").collapse(); // Collapse the accordion section
                        $$('a5').scrollTo(100, 0); // Scroll to a specific position
                    }
                }
            ]
        };

        // Define the buttons layout for the second form
        const buttons2 = {
            padding: 10,
            cols: [
                {
                    view: "button", value: _("Limpiar"),
                    click: () => {
                        $$('myForm2').setValues($$('myForm2').getCleanValues()); // Reset form values
                        $$('CountrySelect').setValue(($$('myForm2').getCleanValues()).CountrySelect); // Reset country selection
                        $$('Datepicker').setValue(""); // Clear datepicker value
                    }
                },
                {
                    view: "button", value: _("Consultar"), hotkey: "enter", type: "form",
                    click: () => {
                        const filterdata = $$('myForm2').getValues(); // Get filter data from the second form
                        if (devConfig.getCountryReport()) {
                            filterdata.CountrySelect = profile.Settings.ReportCountry; // Set country filter if enabled
                        }
                        delete filterdata['CountrySelect2']; // Remove unnecessary fields
                        if (profile.typeDate !== 2) {
                            delete filterdata['Date'];
                            delete filterdata['DateDelete2'];
                            delete filterdata['DatePay2'];
                        } else {
                            if (true) {
                                delete filterdata['Datepicker'];
                                delete filterdata['DateDelete'];
                                delete filterdata['DatePay'];
                            }
                        }
                        this.app.callEvent("bonusReport:filter", [filterdata]); // Trigger filter event with the collected data
                    }
                }
            ]
        };

        // Define the accordion section layout
        const accordion_section = {
            rows: [
                {
                    multi: true,
                    view: "accordion",
                    css: "betShop",
                    collapsed: true,
                    paddingY: 10,
                    type: "clean",
                    rows: [
                        {
                            header: _("Detalles"), body: {
                                padding: 10,
                                rows: [upper_section2] // Include the upper section 2
                            }
                        }
                    ]
                }
            ]
        }

        // Define the accordion section 2 layout
        const accordion_section2 = {
            type: "wide",
            rows: [
                {
                    multi: true,
                    view: "accordion",
                    css: "betShop",
                    collapsed: false,
                    type: "clean",
                    rows: [
                        {
                            header: _("Filtros"), id: "b5", body: {
                                padding: 10,
                                rows: [upper_section, accordion_section, buttons] // Include the upper section and buttons
                            }
                        }
                    ]
                }
            ]
        };

        // Define the scrollable accordion section layout
        const accordion_section3 = {
            view: "scrollview", scroll: "xy",
            body: {
                padding: 10,
                rows: [upper_section, accordion_section] // Include the upper section and accordion section
            }
        };

        // Define the filter popup window UI
        const filterPopup = webix.ui({
            view: "window",
            move: true,
            id: "filterPopup",
            fullscreen: true,
            head: {
                view: "toolbar",
                cols: [
                    {view: "label", label: _("Filtros"), align: "center"}, // Title for the popup
                    {
                        view: "icon", icon: "wxi-close", click: function () {
                            this.getTopParentView().hide(); // Close the window on icon click
                        }
                    }
                ]
            },
            modal: true,
            position: "center",
            body: {
                view: "form", id: 'myForm2',
                type: "clean",
                rows: [
                    accordion_section3, buttons2 // Include the accordion section and buttons
                ],
                rules: {
                    "fname": webix.rules.isNotEmpty // Validation rule for the form
                }
            }
        });

        // Return the main form configuration
        return {
            view: "form", id: 'myForm',
            type: "clean",
            rows: [
                (screen.width > 500 && screen.height > 500) ? accordion_section2 : {height: 1, width: 0} // Conditional rendering based on screen size
            ],
            rules: {
                "fname": webix.rules.isNotEmpty // Validation rule for the form
            }
        };
    }
    /**
     * Initializes the grid and sets up UI elements based on screen size and profile type.
     * @param {Object} grid - The grid object to be initialized.
     */
    init(grid) {
        // Waits for the Webix library to be ready before executing the following code.
        webix.ready(function () {
            // Hides specific elements based on the screen width.
            if (screen.width < 500) {
                $$("grav").hide(); // Hides 'grav' element for small screens.
            } else {
                $$("grav2").hide(); // Hides 'grav2' element for larger screens.
            }
            // Checks the profile type and adjusts the visibility of date-related elements accordingly.
            if (profile.typeDate !== 2) {
                $$("Date").hide(); // Hides 'Date' element if typeDate is not 2.
                $$("Datepicker").show(); // Shows 'Datepicker' element.
                $$("DateDelete2").hide(); // Hides 'DateDelete2' element.
                $$("DateDelete").show(); // Shows 'DateDelete' element.
                $$("DatePay2").hide(); // Hides 'DatePay2' element.
                $$("DatePay").show(); // Shows 'DatePay' element.
            } else {
                // If profile type is 2, adjusts visibility of date elements differently.
                if (true) { // This condition is always true; consider removing it for clarity.
                    $$("Date").show(); // Shows 'Date' element.
                    $$("Datepicker").hide(); // Hides 'Datepicker' element.
                    $$("DateDelete2").show(); // Shows 'DateDelete2' element.
                    $$("DateDelete").hide(); // Hides 'DateDelete' element.
                    $$("DatePay2").show(); // Shows 'DatePay2' element.
                    $$("DatePay").hide(); // Hides 'DatePay' element.
                }
            }
        });
        // Retrieves the current language setting from the app's locale service.
        const lang = this.app.getService("locale").getLang();
        // Attaches an event listener to the 'Datepicker' element for after render actions.
        $$('Datepicker').attachEvent("onAfterRender", function () {
            devConfig.setDateModal(lang); // Sets the date modal configuration based on the current language.
        });
    }
}

// FILE DOCUMENTED
